module.exports = {"140921100":"晋昌镇","140921101":"河边镇","140921102":"宏道镇","140921200":"杨芳乡","140921201":"南王乡","140921202":"蒋村乡","140921203":"神山乡","140921204":"季庄乡","140921205":"受禄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140921.json
// module id = 347
// module chunks = 0